// CÓMO SE ESCRIBE UNA FORMA DE PAGO. Un sitio, una respuesta.
//
// La lista es la del CHECK `orders_payment_method_check` de la base, medida:
// `stripe · efectivo · transferencia · bizum · otro · regalo · gratis`. Si un
// día crece, crece en la migración y aquí.
//
// ⚠️ Esto SALIÓ DE UN FALLO, y conviene que quede escrito. La descarga del
// inventario necesitaba rotular la forma de pago y escribí la tabla de memoria,
// con `card`, `cash` y `transfer` en inglés. Pasó los tests —el fixture usaba
// mis propias claves— y se cayó al generar el fichero con datos de producción,
// donde el valor es `stripe`: la celda salía con la palabra cruda. Una tabla de
// rótulos inventada es verde hasta que la mira alguien de fuera.
//
// ⚠️ LO QUE NO ENTRA AQUÍ, aunque se parezca: `METHOD_LABELS` de
// `BonosManualesPage` NO es una copia de esto. Son las cuatro que dirección
// puede cobrar A MANO, y es un selector: contesta «qué puedo elegir», no «cómo
// se escribe lo que ya pasó». Juntarlas pondría `stripe` en un desplegable
// donde no se puede elegir, que es peor que tener dos listas.

/** Las siete formas que admite la base, en el orden en que se usan. */
export const FORMAS_DE_PAGO = [
  'stripe',
  'efectivo',
  'transferencia',
  'bizum',
  'otro',
  'regalo',
  'gratis',
] as const;

const ETIQUETAS: Record<string, string> = {
  stripe: 'Tarjeta',
  efectivo: 'Efectivo',
  transferencia: 'Transferencia',
  bizum: 'Bizum',
  otro: 'Otro',
  regalo: 'Regalo',
  gratis: 'Gratis',
};

/**
 * El rótulo de una forma de pago.
 *
 * Un valor que no esté en la lista se devuelve TAL CUAL y no como «—»: si la
 * base gana un método y nadie lo añade aquí, es mejor que la pantalla diga
 * `bizum_pro` —feo, y por tanto visible— que un guion que esconde el hueco.
 */
export function etiquetaDeLaFormaDePago(metodo: string | null | undefined): string {
  if (!metodo) return '';
  return ETIQUETAS[metodo] ?? metodo;
}
